import React, { useContext } from "react";

import {
  ModalContainer,
  ModalContainerBody,
  ModalContainerBodyContainer,
} from "./styled";

import { CoreContext } from "context/CoreContext";
import CardCreators from "components/Cards/Creators";

export default function ModalCreators() {
  const { modal, setModal } = useContext(CoreContext);

  const close = () => {
    setModal(null);
  };

  return (
    <>
      <ModalContainer>
        <ModalContainerBodyContainer>
          <ModalContainerBody>
            <CardCreators
              closeable={close}
              campaign={modal?.item}
              reload={modal?.reload}
            />
          </ModalContainerBody>
        </ModalContainerBodyContainer>
      </ModalContainer>
    </>
  );
}
